import * as Utils from 'web3-utils';
import { AbiCoder as AbiCoder$2 } from 'ethers/utils/abi-coder';
import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';

class AbiCoder {
  constructor(utils, ethersAbiCoder) {
    this.utils = utils;
    this.ethersAbiCoder = ethersAbiCoder;
  }
  encodeFunctionSignature(functionName) {
    if (isObject(functionName)) {
      functionName = this.utils.jsonInterfaceMethodToString(functionName);
    }
    return this.utils.keccak256(functionName).slice(0, 10);
  }
  encodeEventSignature(functionName) {
    if (isObject(functionName)) {
      functionName = this.utils.jsonInterfaceMethodToString(functionName);
    }
    return this.utils.keccak256(functionName);
  }
  encodeParameter(type, param) {
    return this.encodeParameters([type], [param]);
  }
  encodeParameters(types, params) {
    return this.ethersAbiCoder.encode(types, params);
  }
  encodeFunctionCall(jsonInterface, params) {
    return this.encodeFunctionSignature(jsonInterface) + this.encodeParameters(jsonInterface.inputs, params).replace('0x', '');
  }
  decodeParameter(type, bytes) {
    return this.decodeParameters([type], bytes)[0];
  }
  decodeParameters(outputs, bytes) {
    if (isArray(outputs) && outputs.length === 0) {
      throw new Error('Empty outputs array given!');
    }
    if (!bytes || bytes === '0x' || bytes === '0X') {
      throw new Error(`Invalid bytes string given: ${bytes}`);
    }
    const result = this.ethersAbiCoder.decode(outputs, bytes);
    let returnValues = {};
    let decodedValue;
    if (isArray(result)) {
      if (outputs.length > 1) {
        outputs.forEach((output, i) => {
          decodedValue = result[i];
          if (decodedValue === '0x') {
            decodedValue = null;
          }
          returnValues[i] = decodedValue;
          if (isObject(output) && output.name) {
            returnValues[output.name] = decodedValue;
          }
        });
        return returnValues;
      }
      return result;
    }
    if (isObject(outputs[0]) && outputs[0].name) {
      returnValues[outputs[0].name] = result;
    }
    returnValues[0] = result;
    return returnValues;
  }
  decodeLog(inputs, data = '', topics) {
    const returnValues = {};
    let topicCount = 0;
    let value;
    let nonIndexedInputKeys = [];
    let nonIndexedInputItems = [];
    if (!isArray(topics)) {
      topics = [topics];
    }
    inputs.forEach((input, i) => {
      if (input.indexed) {
        if (input.type === 'string') {
          return;
        }
        value = topics[topicCount];
        if (this.isStaticType(input.type)) {
          value = this.decodeParameter(input.type, topics[topicCount]);
        }
        returnValues[i] = value;
        returnValues[input.name] = value;
        topicCount++;
        return;
      }
      nonIndexedInputKeys.push(i);
      nonIndexedInputItems.push(input);
    });
    if (data) {
      let values = this.decodeParameters(nonIndexedInputItems, data);
      let decodedValue;
      nonIndexedInputKeys.forEach((itemKey, index) => {
        decodedValue = values[index];
        returnValues[itemKey] = decodedValue;
        returnValues[nonIndexedInputItems[index].name] = decodedValue;
      });
    }
    return returnValues;
  }
  isStaticType(type) {
    if (type === 'bytes') {
      return false;
    }
    if (type === 'string') {
      return false;
    }
    if (type.indexOf('[') && type.slice(type.indexOf('[')).length === 2) {
      return false;
    }
    return true;
  }
}

function AbiCoder$1() {
  return new AbiCoder(Utils, new AbiCoder$2());
}

export { AbiCoder$1 as AbiCoder };
